import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-gold bg-pitch pb-16" data-id="element-73" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-74" data-mp="3gh3sii3dgcgq">
        <p className="text-xs leading-snug text-white" data-id="element-75" data-mp="32pfci3q053uh">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-76" data-mp="36nd1p6jrvpxv">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, licencias deportivas, certificaciones, capacitación en
          primeros auxilios, protocolos de protección infantil ni las normas
          de seguridad aplicables. Los entrenamientos deben adaptarse a la
          edad, condición física y experiencia de los jugadores.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-77" data-mp="29yxaz74xfaj6">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-gold transition-colors duration-150 ease-out hover:text-white" data-id="element-78" data-mp="2ey0akc250ojr">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-79" data-mp="3gbiliokp7i08">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-80" data-mp="3q8wpvptckgc6">
            Términos y Condiciones
          </a>
          <span className="text-gold" aria-hidden="true" data-id="element-81" data-mp="33xdnwzdzwrz">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-82" data-mp="33e4p5rpsiq3">
            Política de Privacidad
          </a>
          <span className="text-gold" aria-hidden="true" data-id="element-83" data-mp="cv1s8vl5hfma">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-84" data-mp="qt8flhsh3x7p">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}